<script setup lang="ts">
import type { IOfferPrimaryCardDeposit } from './types'
import { UiCardTop } from '~/components/ui/card'

const props = defineProps<IOfferPrimaryCardDeposit>()
</script>

<template>
  <article
    class="PrimaryCard"
    :class="{
      '!border-orange-600 hover:!border-blue-600 [&>span]:hover:bg-blue-600': props.isTop
    }"
  >
    <UiCardTop v-if="props.isTop" />
    <header>
      <div class="flex items-center gap-2 rounded-lg">
        <figure class="flex-shrink-0 rounded-lg">
          <NuxtImg
            :src="props.companyLogo"
            width="40"
            height="40"
            class="min-w-5"
            :alt="props.companyName"
          />
        </figure>
        <div class="flex w-full flex-col gap-0.5">
          <span class="text-sm">{{ props.companyName }}</span>
          <div class="mt-0.5 font-semibold">{{ props.title }}</div>
        </div>
      </div>
      <Heading tag="h3" class="h5 mt-2">
        <NuxtLinkLocale :to="props.url" class="after:absolute after:inset-0">
          <div v-html="props.rate" />
        </NuxtLinkLocale>
      </Heading>
      <div class="text-sm">{{ props.period }}</div>
    </header>
  </article>
</template>
